
<div class="container">
 	<div class="row">
		  <label for="formFile" class="form-label">Tipo de Archivo : {{ modalData.TIPO_ARCHIVO }} </label>     	
      <div class="col-md-6">
           <label for="formFile" class="form-label">Seleccione el archivo a Cargar:</label> 
           <input (change)="this.onFilechange($event)" class="form-control" type="file" id="formFile">
           <button (click)="this.upload()" type="button" class="btn btn-primary mt-3" [disabled]="loading">
           	{{loading ? 'Cargando...' : 'Subir Archivo'}}
           </button>
      </div>
      <div class="col-md-6">      
        <img [src]="imgBase64Path" width="100px">
      </div>
  </div>
</div>


